export var DatasetUpdatesTypes;
(function (DatasetUpdatesTypes) {
    DatasetUpdatesTypes["DATASET_UPDATED"] = "DATASET_UPDATED";
    DatasetUpdatesTypes["PROGRAM_TREE_UPDATED"] = "PROGRAM_TREE_UPDATED";
})(DatasetUpdatesTypes || (DatasetUpdatesTypes = {}));
//# sourceMappingURL=DatasetUpdate.js.map